import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {Subject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ReferenceResourceService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  public url(method: string, id: number = undefined, submethod: string = undefined) {
    let url = this.config.api + '/api/' + method;
    if (id) url += '/' + id;
    if (submethod) url += '/' + submethod;
    return url;
  }

  getAll() {
    return this.http.get<any>(this.url('referenceResources'));
  }
  getReferenceResources(controlItemId) {
    return this.http.get<any>(this.url('referenceResources', controlItemId));
  }
  deleteReferenceResource(referenceResourceId: number) {
    return this.http.delete<any>(this.url('referenceResource', referenceResourceId));
  }

  saveReferenceResource(referenceResource: any) {
    return this.http.post<any>(this.url('referenceResource'), referenceResource);
  }
  deleteList(listId) {
    return this.http.delete<any>(this.url('referenceResourcesList', listId));
  }
  saveList(list) {
    return this.http.post<any>(this.url('referenceResourcesList'), list);
  }
  upload(entity: File, name: string) {
    let formData = new FormData();
    formData.append(entity.name, entity, name);

    return this.http.post<any>(this.url('referenceResource/upload'), formData);
  }

  addReference(itemId, controlItemId) {
    return this.http.post<any>(this.url('referenceResource/references', itemId, controlItemId), {})
  }

  removeReference(referenceId) {
    return this.http.delete<any>(this.url('referenceResource/references', referenceId))
  }
}
